export default "__VITE_ASSET__e573fb46__"